import { render, staticRenderFns } from "./svge.vue?vue&type=template&id=c518bb5e&"
import script from "./svge.vue?vue&type=script&lang=js&"
export * from "./svge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports